import React from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Navbar from '../Navbar/Navbar'
import { Outlet } from 'react-router-dom'
import "./Layout.css"

export default function DashboardLayout() {
  return (
    <div className='layout'>
        <div className='layout-nav-wrapper'>
        <div className='layoutSidebar'>
            <Sidebar/>
         </div>
        <div className='layout-wrapper'>
        <div className='layoutNavbar'>
            <Navbar/>        
          </div>
          <div className='layout-wrapper-sub'>
          <Outlet/>
          </div>
        </div>
        </div>
    </div>
  )
}
